import axios from 'axios'
import { useRouter } from 'vue-router'
import Account from './Account';
import { jwtDecode } from "jwt-decode";
import { useStore } from '../services/store'

export default () => {
    let crtAxios = axios.create({
        baseURL: Account.getHost()
    });

    let refreshingPromise = null;

    crtAxios.interceptors.request.use(async (config) => {

        if (refreshingPromise) {
            await refreshingPromise;
        }

        let accessToken = localStorage.getItem('access_token');
        let claims = null;
        
        const now = new Date();
        now.setSeconds(now.getSeconds() + 100);
        if(accessToken) {
            try {
                claims = jwtDecode(accessToken);
            } catch {
                claims = null;
            }
        }
        const expiration = claims == null ? new Date(1 * 1000) : new Date(claims.exp * 1000);
        
        if (now > expiration) {
            if (!refreshingPromise) {
                refreshingPromise = () => Account.refreshToken().then((response) => {
                    localStorage.setItem('access_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);
                }).catch( (ex) => {
                    console.log(ex);
                });

            }
            await refreshingPromise();
            accessToken = localStorage.getItem('access_token');
            refreshingPromise = null;
        }
        const store = useStore()
        if (accessToken && config.headers) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
            config.headers['organizationId'] = store.organization;
        }
        else {
            return Promise.reject("Unautorized");
        }

        return config;
    },
    
    function () {
        var router = useRouter();
        if(!Account.isLoggedIn())
            router.push('/login')
    });
    return crtAxios;
}